import { render, staticRenderFns } from "./ClimateTable.vue?vue&type=template&id=36ed9020&"
import script from "./ClimateTable.vue?vue&type=script&lang=js&"
export * from "./ClimateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports